import { formatTime } from '../../../utils/utilities';
import { APP_DATE_FORMAT, DEFAULT_REPORT_TITLE } from '../../../utils/constants';

import css from './pdf.module.scss';
import russelsmithLogo from '../../../assets/images/brand.png';

interface PDFInfoSheetProps {
	companyUrl: string;
	reportTitle: string;
	facility: string;
	documentNo: string;
	clientName: string;
}

const PDFInfoSheet = (props: PDFInfoSheetProps) => {
	return (
		<div className="p-3">
			<div className="border-dark d-flex  flex-column justify-content-center align-items-center">
				<div className={css['pdf-info-sheet']}>
					<img src={props.companyUrl} alt={props.clientName} />

					<h1>{props.facility}</h1>

					<img src={russelsmithLogo} alt="Russel Smith" />

					<h2>{DEFAULT_REPORT_TITLE}</h2>

					<h3>{props.reportTitle}</h3>

					<h4>DOCUMENT NO: {props.documentNo}</h4>

					<div className="container-fluid mt-auto overflow-hidden">
						<div className="row">
							<div className={css['pdf-overview'] + ' col'}>K01</div>
							<div className={css['pdf-overview'] + ' col'}>
								{formatTime(new Date(), APP_DATE_FORMAT)}
							</div>
							<div className={css['pdf-overview'] + ' col'}>
								Issued for Review and approval
							</div>
							<div className={css['pdf-overview'] + ' col'}>EA</div>
							<div className={css['pdf-overview'] + ' col'}>ST</div>
							<div className={css['pdf-overview'] + ' col'}>BF</div>
						</div>
						<div className="row">
							<div className={css['pdf-overview-title'] + ' col'}>Rev</div>
							<div className={css['pdf-overview-title'] + ' col'}>Date</div>
							<div className={css['pdf-overview-title'] + ' col'}>
								Description
							</div>
							<div className={css['pdf-overview-title'] + ' col'}>Orig</div>
							<div className={css['pdf-overview-title'] + ' col'}>Chk</div>
							<div className={css['pdf-overview-title'] + ' col'}>Appr</div>
						</div>
						<div className="row">
							<div className={css['pdf-approval'] + ' col'}>
								<div className="row mb-4">
									<div className="col">APPROVED BY:</div>
									<div className="col"></div>
								</div>
								<div className="row">
									<div className="col">DATE:</div>
									<div className="col"></div>
								</div>
							</div>
							<div className={css['pdf-approval'] + ' col'}>
								<div className="row mb-4">
									<div className="col">COMPANY APPROVAL:</div>
									<div className="col"></div>
								</div>
								<div className="row">
									<div className="col">DATE:</div>
									<div className="col"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PDFInfoSheet;
